module.exports = __webpack_public_path__ + "img/img_32389_0_242.bfc98898.png";